import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const NotFound = () => {
  const { translate } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div
      className="flex-1 flex items-center justify-center -mx-4 sm:-mx-6 lg:-mx-8 py-8 overflow-hidden"
      style={{ backgroundColor: "var(--color-bg)" }}
    >
      <div className="text-center max-w-2xl mx-auto px-8 relative">
        {/* Large 404 background text */}
        <div
          className="select-none font-black leading-none pointer-events-none"
          style={{
            fontSize: "clamp(10rem, 25vw, 16rem)",
            color: "var(--color-border)",
            opacity: 0.8,
          }}
        >
          404
        </div>

        {/* Robot illustration overlapping the 404 */}
        <img
          src="/notFound.png"
          alt="404 Robot"
          className="mx-auto -mt-44 mb-4 relative"
          style={{ width: "320px", maxWidth: "100%", filter: "sepia(1) hue-rotate(100deg) saturate(0.5)", opacity: 0.8 }}
          draggable={false}
        />

        {/* Text */}
        <h2
          className="text-2xl font-bold mb-2"
          style={{ color: "var(--color-text-primary)" }}
        >
          {translate("pageNotFound") || "Oops! Nothing here..."}
        </h2>
        <p
          className="text-sm mb-2"
          style={{ color: "var(--color-text-secondary)" }}
        >
          {translate("pageNotFoundMessage") ||
            "The page you're looking for doesn't exist or you don't have permission to access it."}
        </p>
        <p
          className="text-xs font-mono mb-8 px-3 py-1.5 rounded-lg inline-block"
          style={{
            color: "var(--color-text-muted)",
            backgroundColor: "var(--color-surface-raised)",
          }}
        >
          {location.pathname}
        </p>

        {/* Actions */}
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="btn-secondary flex items-center gap-2"
          >
            <ArrowLeft size={14} />
            <span>{translate("goBack") || "Go Back"}</span>
          </button>
          <button
            onClick={() => navigate("/")}
            className="btn-primary flex items-center gap-2"
          >
            <Home size={14} />
            <span>{translate("goHome") || "Go Home"}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
